module.exports = __webpack_public_path__ + "catalog/items/firesafety/fire-blanket/fire-blanket.svg";